document.addEventListener("DOMContentLoaded", () => {
    const body = document.body;
    const redirectUrl = document.getElementById("quiz-redirect-url")?.value;
    const questionSections = [...document.querySelectorAll(".quiz-310-question-section")];
    const resultSections = [...document.querySelectorAll(".quiz-310-result-section")];
    const newsletter_form = document.querySelector('.q310result-newsletter form');
    const total = questionSections.length + resultSections.length;
    /* Shopify Newsletter Recaptcha Fix */
    const params = new URLSearchParams(window.location.search);
    const storedRes = sessionStorage.getItem('quiz310_quiz_ret_url');

    if (params.has("contact_posted") && storedRes) {
        console.log( 'Success Quiz Form' );
        sessionStorage.removeItem('quiz310_quiz_ret_url');
        window.location.href = storedRes;
        return;
    }else{
        sessionStorage.removeItem('quiz310_quiz_ret_url');
    }

    let currentIndex = 0,
        structuredAnswers = {};
    const quizAnswers = [];

    /* Initial Setup question sections + progress bar */
    questionSections.forEach((section, index) => {
        const stepEl = section.querySelector(".q310question-step");
        const barEl = section.querySelector(".q310question-pbar small");
        const percent = ((index + 1) / total) * 100;

        if (stepEl) stepEl.textContent = `${index + 1} out of ${total}`;
        if (barEl) barEl.style.width = percent + "%";

        if (index === 0) section.classList.add("active");
    });
    if (resultSections[0]) {
        resultSections[0].querySelector(".q310question-step").textContent = `${total} out of ${total}`;
    }

    /* get answers from a section */
    function getAnswers(section) {
        const values = [];
        const choiceInputs = section.querySelectorAll(".q310q-answer:checked");
        const textInputs = section.querySelectorAll("input[type='text']");

        choiceInputs.forEach(input => values.push(input.value));
        textInputs.forEach(input => {
            if (input.value.trim() !== "") values.push(input.value.trim());
        });

        return values;
    }

    /* switch section */
    function switchSection(newIndex, btn = 'next') {
        questionSections[currentIndex].classList.remove("active");
        questionSections[currentIndex].classList.remove("next");
        questionSections[currentIndex].classList.remove("back");
        currentIndex = newIndex;
        questionSections[currentIndex].classList.add("active");
        questionSections[currentIndex].classList.add(btn);
    }

    /* Continue button */
    document.addEventListener("click", (e) => {
        if (!e.target.matches(".continue-btn")) return;

        const currentSection = questionSections[currentIndex];
        const notice = currentSection.querySelector(".notice");

        const answers = getAnswers(currentSection);

        if (answers.length === 0) {
            if (notice) notice.textContent = "Please provide an answer before continuing.";
            return;
        }

        if (notice) notice.textContent = "";

        /* Save answers */
        quizAnswers[currentIndex] = {
            question: currentSection.querySelector("[data-question]").dataset.question || `Question ${currentIndex + 1}`,
            answers
        };

        if (currentIndex + 1 < questionSections.length) {
            switchSection(currentIndex + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            currentSection.classList.remove('active');
            if (resultSections[0]) {
                resultSections[0].classList.add('active');
                get_results();
                build_hidden();
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    });

    /* Build Input Hidden */
    function build_hidden() {
      if (!newsletter_form) return;

      newsletter_form.querySelectorAll('input[data-generated="quiz"]').forEach(el => el.remove());
      quizAnswers.forEach(item => {
        const key = item.question.replace(/\s+/g, "_");
        const input = document.createElement("input");
        input.type = "hidden";
        input.id = key;
        input.name = `contact[${key}]`;
        input.value = item.answers.join(",");
        input.setAttribute("data-generated", "quiz");
        newsletter_form.appendChild(input);
      });
    }    

    /* Get Results */
    function get_results() {
        const rawAnswers = quizAnswers.reduce((acc, q, index) => {
          const section = questionSections[index].querySelector('.q310question-body');
          const columnType = section.dataset.column || "separate";
      
          if (columnType === "main") {
            if (!acc.main) acc.main = [];
            acc.main.push({
              [q.question]: q.answers.map(a => a.trim().toLowerCase())
            });
          } else {
            acc[q.question] = q.answers.map(a => a.trim().toLowerCase());
          }
          return acc;
        }, {});
      
        structuredAnswers = quizAnswers.reduce((acc, q, index) => {
          const section = questionSections[index].querySelector('.q310question-body');
      
          if (section.dataset.include !== "true") {
            return acc;
          }
      
          const columnType = section.dataset.column || "separate";
      
          if (columnType === "main") {
            if (!acc.main) acc.main = [];
            acc.main.push({
              [q.question]: q.answers.map(a => a.trim().toLowerCase())
            });
          } else {
            acc[q.question] = q.answers.map(a => a.trim().toLowerCase());
          }
      
          return acc;
        }, {});
      
        const userAnswers = new Set(
          Object.values(structuredAnswers)
            .flatMap(v => (Array.isArray(v) ? v : Object.values(v).flat()))
        );
      
        const blocks = document.querySelectorAll(".q310result-block");
        let bestMatch = null;
        let bestScore = -1;
      
        blocks.forEach(block => {
          const blockAnswers = new Set(
            block.dataset.answer.split(",").map(a => a.trim().toLowerCase())
          );
      
          let score = 0;
          userAnswers.forEach(ans => {
            if (blockAnswers.has(ans)) score++;
          });
      
          if (score > bestScore) {
            bestScore = score;
            bestMatch = block;
          }
        });
      
        if (bestMatch) {
          blocks.forEach(b => (b.style.display = "none"));
          bestMatch.style.display = "block";
      
          const productHandle = bestMatch.querySelector("[data-product]")?.dataset.product || '';
      
          structuredAnswers.product = productHandle;
          rawAnswers.product = productHandle;
        }
    }
      
    /* Submit result */
    const form_submit_btn = document.querySelector('[form="quiz-newsletter-form"]');
    form_submit_btn.addEventListener("click", (e) => {
        // if (!e.target.matches(".newsletter-submit-btn")) return;
        e.preventDefault();
        
        let finalUrl = '';
        const answersParam = encodeURIComponent(JSON.stringify(structuredAnswers));
        if (redirectUrl) {
            finalUrl = `${redirectUrl}${redirectUrl.includes("?") ? "&" : "?"}quiz_answers=${answersParam}`;
            //add ?view=310-qresult.funnelmain for testing remove when go live 
            finalUrl = finalUrl + '&view=310-qresult.funnelmain';
        }

        sessionStorage.setItem('quiz310_quiz_ret_url', finalUrl);

        /* If has newsletter */
        if (newsletter_form) {
            sessionStorage.setItem('quiz310_quiz_ret_url', finalUrl);
            //newsletter_form.submit(); // Enable this when go live so browser will validate
            window.location.href = finalUrl; 
        }else{
            window.location.href = finalUrl;
        }
    });
    

    /* Back button */
    document.addEventListener("click", (e) => {
        if (!e.target.matches(".back-btn")) return;
        if (document.querySelector(".quiz-310-result-section.active")) {
            const activeResult = document.querySelector(".quiz-310-result-section.active");
            if (activeResult) activeResult.classList.remove("active");

            currentIndex = questionSections.length - 1;
            questionSections[currentIndex].classList.add("active");
        } else if (currentIndex > 0) {
            switchSection(currentIndex - 1, 'back');
        }
    });

    /* Make all question section equal in size even in resize */
    function equalizeQuestionHeights() {
        questionSections.forEach(sec => sec.style.minHeight = "auto");
    
        let maxHeight = 0;
        questionSections.forEach(sec => {
            const h = sec.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });
    
        questionSections.forEach(sec => {
            sec.style.minHeight = maxHeight + "px";
        });
    }
    equalizeQuestionHeights();
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equalizeQuestionHeights, 150);
    });
});
